import React, { useEffect, useRef } from "react";
import { useGroup } from "../context/groupContext";
import { useBets } from "../context/betsContext";
import { useAppContext } from "../context";
import { GroupDashboardView } from "../components/GroupDashboardView";

function InfoGroupSelected({ currentUniqueIdentifierSelected, selectedGroup }) {
	const { leaveGroup, loadingLeaveGroup } = useGroup();
	const {
		getInfoLeagueTeamSelectedForLeagueBets,
		infoLeagueTeamSelected,
		loadingLeagueTeamSelected,
		leagueTeamSelectedError,
	} = useBets();
	const { toastMessage } = useAppContext();
	const getInfoLeagueTeamSelectedForLeagueBetsRef = useRef(
		getInfoLeagueTeamSelectedForLeagueBets
	);

	useEffect(() => {
		getInfoLeagueTeamSelectedForLeagueBetsRef.current =
			getInfoLeagueTeamSelectedForLeagueBets;
	}, [getInfoLeagueTeamSelectedForLeagueBets]);

	useEffect(() => {
		getInfoLeagueTeamSelectedForLeagueBetsRef.current(
			currentUniqueIdentifierSelected
		);
	}, [currentUniqueIdentifierSelected]);

	const handleLeaveGroup = async () => {
		if (!window.confirm(`Seguro desea abandonar el grupo ${selectedGroup?.name}`)) {
			return;
		}

		const apiResponse = await leaveGroup(currentUniqueIdentifierSelected);
		if (!apiResponse?.IsSuccess) {
			toastMessage(apiResponse?.Errors?.[0] || "Ha ocurrido un error", "error");
		}
	};

	const handleCopyAccessCode = async (accessCode) => {
		if (!accessCode) {
			return false;
		}

		try {
			await navigator.clipboard.writeText(accessCode);
			toastMessage("Codigo copiado", "info");
			return true;
		} catch (error) {
			toastMessage("No se pudo copiar el codigo", "error");
			return false;
		}
	};

	return (
		<GroupDashboardView
			currentUniqueIdentifierSelected={currentUniqueIdentifierSelected}
			selectedGroup={selectedGroup}
			infoLeagueTeamSelected={infoLeagueTeamSelected}
			loadingLeagueTeamSelected={loadingLeagueTeamSelected}
			leagueTeamSelectedError={leagueTeamSelectedError}
			loadingLeaveGroup={loadingLeaveGroup}
			onRetryLeagueBets={() =>
				getInfoLeagueTeamSelectedForLeagueBets(currentUniqueIdentifierSelected)
			}
			onLeaveGroup={handleLeaveGroup}
			onCopyAccessCode={handleCopyAccessCode}
		/>
	);
}

export { InfoGroupSelected };
